module.exports = __webpack_public_path__ + "static/media/giftcardIcon.d2373cb9.png";